import React, { useEffect } from "react";
import { Card, Statistic } from "antd";

import { Area } from "@ant-design/plots";
import numeral from "numeral";

import CountUp from "react-countup";

import "./CardTotalLastMonth.css";

import data from "./data";

const formatter = (value) => <CountUp end={value} separator="," />;

function CardTotalLastMonth(props) {
  const config = {
    data: props.ticketsLastMonth,
    xField: "Date",
    yField: "Total",
    xAxis: {
      range: [0, 1],
    },
  };

  // const total = props.ticketsLastMonth.reduce((a, e) => {
  //   return a + e.Total;
  // }, 0);

  const total = () => {
    let counter = 0;
    props.ticketsLastMonth.forEach((e) => {
      counter += e.Total;
    });

    return counter;
  };

  const quantity = () => {
    let qty = 0;
    props.ticketsLastMonth.forEach((e) => {
      qty += e.Qty;
    });

    return qty;
  };

  useEffect(() => {
    props.setTotalLM(total);
    props.setQtyLM(quantity);
  }, []);

  // console.log("lastmonth", props.ticketsLastMonth);

  return (
    <Card title={props.title} bordered={true}>
      <div className="card-card">
        {props.ticketsLastMonth ? (
          <div className="sales">
            <div className="salesClientes">
              <Statistic
                title="Clientes"
                value={quantity()}
                // value={props.ticketsLastMonth[0].Qty}
                formatter={formatter}
              />
            </div>
            <div className="salesAmount">
              <Statistic
                title="Total"
                value={total()}
                // value={props.ticketsLastMonth[0].Total}
                formatter={formatter}
              />
              {/* {numeral(props.amount).format("$0,00")} */}
            </div>
          </div>
        ) : (
          "No Data"
        )}
        <div className="area">
          <Area
            width={380}
            height={100}
            animation={true}
            autoFit={true}
            padding="auto"
            //Remove horizontal lines from graph
            yAxis={false}
            smooth={true}
            {...config}
          />
        </div>
      </div>
    </Card>
  );
}

export default CardTotalLastMonth;
